import { defineMessages } from 'react-intl';

export default defineMessages({
  quantity: {
    id: 'components.ProductLayout.title',
    defaultMessage: 'Quantity',
  },
  addToCart: {
    id: 'components.ProductLayout.addToCart',
    defaultMessage: 'ADD TO SHOPPING CART',
  },
  findDealer: {
    id: 'components.ProductLayout.findDealer',
    defaultMessage: 'Find a Dealer',
  },
});
